import styled from 'styled-components';

export const AlertBox = styled.div`
  position: relative;
  background-color: #fff6da;
  border-radius: 0.25rem;
  padding: 0.5rem 0.75rem;

  .row > [class*='col-'] {
    margin-bottom: 0.5rem !important;
  }

  .ia-badge {
    position: absolute;
    top: 0.5rem;
    right: 0.75rem;
    width: 20px;
    height: 20px;
    color: #2f80ed;

    path {
      fill: currentColor;
    }
  }
`;
